import { render, staticRenderFns } from "./applyDetails.vue?vue&type=template&id=24e46c64&scoped=true&"
import script from "./applyDetails.vue?vue&type=script&lang=js&"
export * from "./applyDetails.vue?vue&type=script&lang=js&"
import style0 from "./applyDetails.vue?vue&type=style&index=0&id=24e46c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e46c64",
  null
  
)

export default component.exports